import { useState } from 'react';

const navLinks = [
  { label: '首页', href: '#top' },
  { label: '今日更新', href: '#latest' },
  { label: '话题墙', href: '#topics' },
  { label: '社区', href: '#community' },
  { label: '常见问题', href: '#faq' },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <div className="bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[68px]">
          <a href="#top" className="flex items-center gap-3 cursor-pointer">
            <span className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-black text-lg md:text-xl">
              黑
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-black text-lg md:text-xl text-foreground-950 tracking-tight">
                黑料福利
              </span>
              <span className="text-[11px] md:text-xs text-foreground-500 mt-1 tracking-wide">
                社区话题 · 每日更新
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="cursor-pointer px-3.5 py-2 rounded-md text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              className="cursor-pointer hidden sm:flex w-10 h-10 rounded-md items-center justify-center text-foreground-700 hover:bg-background-100 border border-background-200 transition-colors"
              aria-label="搜索话题"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <a
              href="#community"
              className="cursor-pointer hidden sm:inline-flex whitespace-nowrap items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
            >
              <i className="ri-chat-smile-2-line w-4 h-4 flex items-center justify-center"></i>
              加入讨论
            </a>
            <button
              type="button"
              onClick={() => setOpen((prev) => !prev)}
              className="cursor-pointer md:hidden w-10 h-10 rounded-md flex items-center justify-center text-foreground-900 border border-background-200 bg-background-100"
              aria-label="打开菜单"
              aria-expanded={open}
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden pb-4 pt-1 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="cursor-pointer px-3 py-3 rounded-md text-sm font-medium text-foreground-800 bg-background-100 hover:bg-primary-50 hover:text-primary-600 transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#community"
              onClick={() => setOpen(false)}
              className="cursor-pointer mt-2 whitespace-nowrap inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium"
            >
              <i className="ri-chat-smile-2-line w-4 h-4 flex items-center justify-center"></i>
              加入讨论
            </a>
          </div>
        )}
      </div>
    </div>
  );
}